export const GLOBAL_PATHS = {
  DEFAULT_LANDING: 'training-planner',
  LOGIN: 'auth/login',
} as const;

